<template>
    <form class="form" @submit.prevent="submit">
        <div class="block">
            <div class="form__group">

                <div v-for="gender in titles" class="radio is-inline">
                    <input class="radio__rb" type="radio" name="radio"
                           v-gen.id="gender" required :value="gender"
                           v-model="proxy.gender"/>
                    <label class="radio__label" v-gen.for="gender">
                        {{localizeTitle(gender)}}
                    </label>
                </div>
            </div>
            <div v-for="field in simpleFields" :key="field.name" class="form__group">
                <transition name="fade">
                    <span class="floating-label" v-show="proxy[field.name]">{{getFieldLabel(field)}}</span>
                </transition>
                <i v-if="field.icon" class="form__input__icon" :class="field.icon"></i>
                <input class="form__input--text underline" :type="field.type" :required="field.required" v-gen.id="field.name"
                       :placeholder="getFieldLabel(field)"
                       :class="field.icon && 'has-icon'"
                       v-model="proxy[field.name]">
            </div>
        </div>

        <div class="alert--info has-bottom-margin">
            {{$t('account_info.address_information')}}
            <a target="_blank" :href="contactUrl">{{$t('account_info.address_information_contact')}}</a>
        </div>

        <button type="submit" class="button--cta" :class="{loading: submitting}" :disabled="!canSubmit">
            {{$t('form.account_info.button_submit')}}
        </button>
        <router-link :to="{name: 'account'}" tag="button" class="button pull-left">
            {{$t('common.button.go_back')}}
        </router-link>
    </form>
</template>
<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import vSelect from 'vue-select';
    import {
        GET_FIELD, SET_FIELD,
        IS_DIRTY, RESET_FIELDS,
        SUBMIT_ACCOUNT_DETAILS, FIELDS,
    } from '../../store/modules/account_details';
    import _ from 'lodash';

    @Component({
        components: {
            vSelect,
        }
    })
    export default class AccountInfoForm extends Vue {
        account;
        simpleFields = [
            {name: 'first_name', required: true, type: 'text'},
            {name: 'last_name', required: true, type: 'text'},
            {name: 'telephone_number', required: false, type: 'tel', icon: 'mdi mdi-phone'},
            {name: 'mobile_number', required: false, type: 'tel', icon: 'mdi mdi-cellphone'},
            {name: 'email_address', required: true, type: 'email', icon: 'mdi mdi-email-outline'},
        ];
        submitting = false;

        created() {
            window.scrollTo(0,0);
            this.account = _.mapValues(_.mapKeys(FIELDS), field => this.$store.getters[GET_FIELD](field));
        }

        get contactUrl(){
            return this.$t('account_info.address_information_contact_url');
        }

        get proxy() {
            const store = this.$store;
            const names = ['gender', ...this.simpleFields.map(field => field.name)];
            return names.reduce((obj, field) => {
                Object.defineProperty(obj, field, {
                    get: () => store.getters[GET_FIELD](field),
                    set: (value) => store.commit(SET_FIELD, {field, value}),
                });
                return obj;
            }, {});
        }

        get titles() {
            return ['M', 'F'];
        }

        localizeTitle(title) {
            return this.$t('common.account_title.' + title);
        }

        getFieldLabel(field) {
            const label = this.$t('form.account_info.label_' + field.name);
            return field.required ? label + ' *' : label;
        }

        get canSubmit() {
            return !this.submitting && this.$store.getters[IS_DIRTY];
        }

        submit() {
            this.submitting = true;
            this.$store.dispatch(SUBMIT_ACCOUNT_DETAILS)
                .then(()=>{
                    this.$notify.success(this.$t('form.account_info.notify_success'));
                    this.$router.replace({
                        name: 'account'
                    });
                })
                .catch(error => {
                    this.$notify.error(this.$t('form.account_info.notify_failure'));
                })
                .finally(() => this.submitting = false);
        }

        beforeRouteLeave(to, from, next) {
            if (!this.$store.getters[IS_DIRTY]) {
                // Form not dirty, continue leaving
                next();
                return;
            }
            if (window.confirm(this.$t('common.question_unsaved_changes'))) {
                // Form dirty and confirmed leave
                this.$store.commit(RESET_FIELDS);
                next();
            } else {
                // Form dirty and cancelled
                next(false);
            }
        }
    }
</script>

<style>
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
    transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: scaleY(0);
}
</style>



// WEBPACK FOOTER //
// src/components/account/AccountInfoForm.vue